import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseHoursReportsKey } from '@/hooks'
import {
  HoursReport,
  APIErrorResponse,
  PostHoursReportingApprove,
} from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePostHoursReportDecline = ({
  id,
}: Pick<HoursReport, 'id'>): UseMutationResult<
  HoursReport,
  APIErrorResponse,
  PostHoursReportingApprove
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const hoursReportsListKey = getUseHoursReportsKey()

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/hr/${id}/decline/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(hoursReportsListKey)
      },
    }
  )
}
